var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRemorca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.67 87.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#30333d;}.cls-2{fill:#2e333e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.72,68.93c1.48,0,2,.39,1.95,1.92,0,5,0,5-5,5-12.7,0-25.41.06-38.09,0-1.64,0-2.06.43-2,2,.14,2.29,0,4.59,0,6.9,0,1.09-.39,1.52-1.49,1.45-1.39-.07-2.78-.06-4.17,0-1,0-1.26-.36-1.24-1.29,0-2.48,0-5,0-7.43,0-1.09-.19-1.58-1.46-1.67a6.6,6.6,0,0,1-5.84-4.92c-.45-1.44-.21-2,1.39-1.92,4.78.07,9.56,0,14.33,0H150C159.22,69,168.47,69,177.72,68.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.25,7.84c0-5.51-2.41-7.84-7.86-7.84h-35L7.73,0C2.62,0,0,2.66,0,7.72V70.48a12.08,12.08,0,0,0,.07,2C.45,74.93,2.13,76,5.2,75.8c2.25-.15,3.41-1.41,3.45-3.81,0-2.17,0-4.35,0-6.53,0-.53-.11-1.19.72-1.19H17.8c-5.87,6.45-6.58,12.43-2.29,17.67a14.62,14.62,0,0,0,18.9,2.87A11.94,11.94,0,0,0,40.3,75c.24-4.27-1.59-7.74-5.08-10.65H49.08C46.08,67.06,44,70,43.91,74a12,12,0,0,0,4.62,9.8,14.6,14.6,0,0,0,19.6-1c5-5.27,4.39-11.93-1.82-18.51h2.11q27,0,54.06,0c12.59,0,25.17,0,37.75-.07,4.59,0,7-2.63,7-7.18Q167.32,32.42,167.25,7.84ZM29,79.15a6.2,6.2,0,0,1-2.39.45,5.85,5.85,0,0,1-2.72-.66,5.28,5.28,0,0,1-2.74-3.48c0-.06,0-.12,0-.17l0-.18c0-.12,0-.24-.05-.36a1.21,1.21,0,0,0,0-.19c0-.12,0-.24,0-.36h0s0-.08,0-.12a5,5,0,0,1,1.28-3,5.83,5.83,0,0,1,4.42-2c3.36.06,5.53,2.18,5.5,5.4A5,5,0,0,1,29,79.15Zm34.49-4.74a5.52,5.52,0,0,1-.17,1.22A5.34,5.34,0,0,1,60.37,79a5.61,5.61,0,0,1-2.52.56c-3.27,0-5.69-2.32-5.64-5.3h0a5.63,5.63,0,0,1,11.24.11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemorca);
export default __webpack_public_path__ + "static/media/IconRemorca.b2b88414b2595069e83952099311c843.svg";
export { ForwardRef as ReactComponent };